import { useLocation, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import { Add, SwapVert, CallMade } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    position: "fixed",
    bottom: 0,
    borderWidth: "1px",
    borderTop: "solid",
    borderColor: theme.palette.grey[900],
    borderTopLeftRadius: theme.spacing(0.4),
    borderTopRightRadius: theme.spacing(0.4),
    zIndex: theme.zIndex.drawer + 1,
  },
}));

export default function BottomPageNavigation() {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();

  return (
    <BottomNavigation
      value={"/" + location.pathname.split("/")[1]}
      onChange={(_event, newValue) => {
        history.push(newValue);
      }}
      showLabels
      className={classes.root}
    >
      <BottomNavigationAction label="Swap" value="/" icon={<SwapVert />} />
      <BottomNavigationAction label="Pools" value="/pools" icon={<Add />} />
      <BottomNavigationAction label="Staking" value="/staking" icon={<Add />} />
      {/* <BottomNavigationAction
        label="Dex"
        href="https://dex.cyclos.io"
        target="_blank"
        icon={<CallMade />}
      /> */}
    </BottomNavigation>
  );
}
